import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'features';
export const keyPrefix = 'assign_permission_tags_to_all_in_department';

export const useAssignPermissionTagsToAllInDepartmentTranslation = ():
UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    label: 'Назначать всем в подразделении',
    toast_error: 'Не удалось изменить назначение тега доступа',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    label: 'Assign to everyone in department',
    toast_error: 'Failed to update access tag assignment',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    label: 'Asignar a todos en el departamento',
    toast_error: 'Falha ao alterar a atribuição da etiqueta de acesso',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    label: 'Atribuir a todos no departamento',
    toast_error: 'No se pudo cambiar la asignación de la etiqueta de acceso',
  },
}) : {}) as Record<string, unknown>;
